import React from "react";
import { NavLink } from "react-router-dom";
import "../style/navBar.css";

const NavBar = ({ user }) => {
  const btn = document.getElementById("nav-bar-toggler-btn");

  const handleClick = () => {
    if (getComputedStyle(btn).display != "none") btn.click();
  };

  return (
    <nav className="navbar navbar-expand-lg ">
      <NavLink
        className="navbar-brand me-2"
        to="/"
        onClick={() => {
          const btn = document.getElementById("nav-bar-toggler-btn");
          const classList = btn.classList;
          if (!classList.contains("collapsed")) handleClick();
        }}
      >
        <img src="logo.png" id="cve-logo" className="logo" />
      </NavLink>
      <button
        className="navbar-toggler"
        id="nav-bar-toggler-btn"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>
      <div
        className="collapse navbar-collapse farsi-header-for-navBar"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav mr-auto">
          <NavLink
            className="nav-item nav-link"
            to="/"
            onClick={() => handleClick()}
          >
            صفحه‌اصلی
          </NavLink>
          {!user.username && (
            <NavLink
              className="nav-item nav-link"
              to="/login"
              onClick={() => handleClick()}
            >
              ورود
            </NavLink>
          )}
          {!user.username && (
            <NavLink
              className="nav-item nav-link"
              to="/register"
              onClick={() => handleClick()}
            >
              ثبت‌نام
            </NavLink>
          )}
          {user.username && (
            <NavLink
              className="nav-item nav-link"
              to="/profile"
              onClick={() => handleClick()}
            >
              پروفایل
            </NavLink>
          )}
          {user.username && (
            <NavLink
              className="nav-item nav-link"
              to="/statistics"
              onClick={() => handleClick()}
            >
              آمار
            </NavLink>
          )}
          {user.username && (
            <NavLink
              className="nav-item nav-link"
              to="/search-program"
              onClick={() => handleClick()}
            >
              جستجو هوشمند
            </NavLink>
          )}

          {user.username && (
            <NavLink
              className="nav-item nav-link"
              to="/manual-search-program"
              onClick={() => handleClick()}
            >
              جستجو دستی
            </NavLink>
          )}
          {user.username && (
            <NavLink
              className="nav-item nav-link"
              to="/cpes-with-new-cves"
              onClick={() => handleClick()}
            >
              آسیب‌پذیری‌های جدید
            </NavLink>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
/*
    <nav className="navbar navbar-expand-lg farsi-header-for-navBar ">
      <div className="navbar-nav">
        <NavLink className="nav-item nav-link" to="/">
          صفحه‌اصلی
        </NavLink>

        {!user.username && (
          <NavLink className="nav-item nav-link" to="/login">
            ورود
          </NavLink>
        )}

        {!user.username && (
          <NavLink className="nav-item nav-link" to="/register">
            ثبت‌نام
          </NavLink>
        )}
        {user.username && (
          <NavLink className="nav-item nav-link" to="/profile">
            {user.username}
          </NavLink>
        )}

        {user.username && (
          <NavLink className="nav-item nav-link" to="/statistics">
            آمار
          </NavLink>
        )}

        {user.username && (
          <NavLink className="nav-item nav-link" to="/search-program">
            جستجوی برنامه
          </NavLink>
        )}
      </div>
    </nav>*/

/*
import React, { useState, useEffect } from 'react'

export default function App() {
	const [screenSize, setScreenSize] = useState(getCurrentDimension());

  	function getCurrentDimension(){
    	return {
      		width: window.innerWidth,
      		height: window.innerHeight
    	}
  	}
  
  	useEffect(() => {
    		const updateDimension = () => {
      			setScreenSize(getCurrentDimension())
    		}
    		window.addEventListener('resize', updateDimension);
    
		
    		return(() => {
        		window.removeEventListener('resize', updateDimension);
    		})
  	}, [screenSize])
  	return (
    	<div>
      		<ul>
        		<li>Width: <strong>{screenSize.width}</strong></li>
        		<li>Height: <strong>{screenSize.height}</strong></li>
      		</ul>    
    	</div>
  	)
}

*/

/*

const NavBar = ({ user }) => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light farsi-header-for-navBar">
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto">
          <NavLink className="nav-item nav-link" to="/">
            صفحه‌اصلی
          </NavLink>

          {!user.username && (
            <NavLink className="nav-item nav-link" to="/login">
              ورود
            </NavLink>
          )}

          {!user.username && (
            <NavLink className="nav-item nav-link" to="/register">
              ثبت‌نام
            </NavLink>
          )}
          {user.username && (
            <NavLink className="nav-item nav-link" to="/profile">
              {user.username}
            </NavLink>
          )}

          {user.username && (
            <NavLink className="nav-item nav-link" to="/statistics">
              آمار
            </NavLink>
          )}

          {user.username && (
            <NavLink className="nav-item nav-link" to="/search-program">
              جستجوی برنامه
            </NavLink>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;

*/

/*
<nav className="navbar navbar-expand-lg farsi-header-for-navBar ">
      <div className="navbar-nav">
        <NavLink className="nav-item nav-link" to="/">
          صفحه‌اصلی
        </NavLink>

        {!user.username && (
          <NavLink className="nav-item nav-link" to="/login">
            ورود
          </NavLink>
        )}

        {!user.username && (
          <NavLink className="nav-item nav-link" to="/register">
            ثبت‌نام
          </NavLink>
        )}
        {user.username && (
          <NavLink className="nav-item nav-link" to="/profile">
            {user.username}
          </NavLink>
        )}

        {user.username && (
          <NavLink className="nav-item nav-link" to="/statistics">
            آمار
          </NavLink>
        )}

        {user.username && (
          <NavLink className="nav-item nav-link" to="/search-program">
            جستجوی برنامه
          </NavLink>
        )}
      </div>
    </nav>
    */
